import React from "react";

function HowToUse(props){
    return (
        <>
        <div class="modal-window">
            <div class="howtouse">

                <h2>How to use this app:</h2>
                <p>This app keeps track of your daily activities and lets you know how productive your day has been.
                I created this because I always tried to determine if my day could have been more productive.
                </p>
                <p>To add an item to the tracker, hit the <span class="txt-btn">+</span> button.</p>
                <p>To reset your daily progress, hit the <span class="txt-btn">Reset</span> button. </p>
                <p> For physical records of your daily productivity, hitting 
                <span class="txt-btn">Export</span> will display your daily activities in a printable format. </p>

                <p>The <span class="txt-btn txt-btn-green">Save</span> and <span class="txt-btn txt-btn-green">Load</span> buttons will save and load your
                current activities to your browsers local storage. This lets you backup your activities.
                <strong>By default the app will save your activities 
                    to local storage as you save them.</strong>
                </p> 
                    
                <p>Pressing <span class="txt-btn txt-btn-red">Clear</span> will 
                erase all saved activities.</p>

                <h2>Credits:</h2>
                <p>&copy; Sanobelk / SitesByStephan 2023</p>

                <button onClick={props.click}>Close Window</button>


            </div>
        </div>
        
        </>
    )
}


export default HowToUse;